import api from "../api/axios";

export const enviarContacto = async (data) => {
    const response = await api.post("/public/contacto", data);

    return response.data;
};